import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, mergeProps as _mergeProps, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "mb-4 d-flex" }
const _hoisted_2 = { class: "lh-0 mb-3" }
const _hoisted_3 = { class: "d-flex align-items-center w-100" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex-fill" }
const _hoisted_6 = { class: "mb-0" }
const _hoisted_7 = {
  tabindex: "",
  style: {"color":"inherit"},
  class: "cursor-pointer"
}
const _hoisted_8 = { class: "lh-primary" }
const _hoisted_9 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_11 = { class: "text-right pl-4" }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 0,
  class: "mr-2"
}

import SelectIntegrationAuthDialog from "~/cabinet/vue/client/integrations/SelectIntegrationAuthDialog.vue";
import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import IntegrationAuthDialog from "~/cabinet/vue/client/integrations/IntegrationAuthDialog.vue";
import Dictionary from "~/ts/library/Dictionary";
import {INTEGRATION_PLATFORM_TYPE_CRM, PlatformInterface} from "~/cabinet/ts/data/integrations/Platform";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {computed, nextTick, ref, watch} from "vue";
import BigIconFlexButton from "~/cabinet/vue/interface/button/BigIconFlexButton.vue";
import BigIconFlexButtonWrapper from "~/cabinet/vue/interface/button/BigIconFlexButtonWrapper.vue";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import StatusTag from "~/cabinet/vue/interface/StatusTag.vue";
import Auth from "~/cabinet/ts/data/integrations/Auth";
import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";
import IntegrationState from "~/cabinet/vue/client/online/config/integrations/IntegrationState.vue";
import MyIconButton from "~/cabinet/vue/interface/button/MyIconButton.vue";
import getAuthById from "~/cabinet/vue/client/online/config/integrations/getAuthById";
import AdditionalAuthConfigDialog from "~/cabinet/vue/client/integrations/AdditionalAuthConfigDialog.vue";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import useOnlineChatComponent from "~/cabinet/vue/client/online/useOnlineChatComponent";


const __default__ = {
    name: "IntegrationsWrapper"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    platformTypeId: {},
    platformsDictionary: {},
    showAdditionalAuthConfigButton: { type: Boolean, default: true },
    showEmptyAsCard: { type: Boolean, default: true },
    authList: {}
  },
  emits: ["reload", "new-auth"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let {siteIsFree, siteId} = useOnlineChatComponent();

let emits = __emit;

let isLoading = computed(() => {
    return !Array.isArray(props.authList);
})

let empty = computed(() => {
    if (Array.isArray(props.authList)) {
        return props.authList.length === 0;
    }
    return undefined;
});

let addIntegrationDialog = ref<{
    visible: boolean,
    platformId: string
}>();

let editIntegrationDialog = ref<{
    visible: boolean,
    auth: Auth,
    platform: PlatformInterface
}>();

let editParentAuthDialog = ref<{
    visible: boolean;
    auth: Auth;
    platform: PlatformInterface;
}>();

let integrationStates = ref<Dictionary<{ descr: string, isCritical: boolean }>>();
let balance = ref<Dictionary<{ descr: string, sum: string }>>();
let channels = ref<Dictionary<{ descr: string, errorDescr?: string, id: string, isValidate: boolean }[]>>();

function showAddIntegrationDialog(platformId?: string) {
    addIntegrationDialog.value = {
        visible: true,
        platformId
    };
}


async function onSelectNewAuth(auth: Auth) {
    emits("new-auth", auth);
}

function reload() {
    emits("reload");
}

let additionalAuthConfigDialogRef = ref<{
    visible: boolean,
    authId: string
}>();

async function editAdditionalChatConfig(auth: Auth) {
    additionalAuthConfigDialogRef.value = {
        authId: auth.id,
        visible: true
    }
}


let integrationsList = computed(() => {
    let result: Dictionary<{ platform: PlatformInterface, authList: Auth[] }> = {};
    let list = props.authList;
    if (Array.isArray(list)) {
        for (let auth of list) {
            let platformId = auth.platformId;
            if (!result[platformId]) {
                let platform = props.platformsDictionary[platformId];
                if (!platform) {
                    continue;
                }
                result[platformId] = {
                    platform: platform,
                    authList: []
                };
            }
            result[platformId].authList.push(auth);
        }
    }
    return ObjectHelper.arrayFromDictionary(result);
});

watch(integrationsList, async () => {
    integrationStates.value = null;
    balance.value = null;
    channels.value = null;
    if (props.authList && !isLoading.value) {
        let idsList: string[] = [];

        for (let auth of props.authList) {
            idsList.push(auth.id);
            let parent = auth.parentAuth;
            if (parent) {
                idsList.push(parent.id);
            }
        }
        let result = await LcabApiRequest.fetch({
            url: `/api/client/online/integration/getIntegrationState`,
            p: {
                idsList,
                siteId: siteId.value
            },
            silent: true
        });
        integrationStates.value = result.getData("validationResult");
        balance.value = result.getData("balanceResult");
        channels.value = result.getData("channelsResult");
    }
}, {deep: true, immediate: true});


function editIntegration(auth: Auth, platform: PlatformInterface) {
    editIntegrationDialog.value = {
        auth,
        platform,
        visible: true
    };
}

function isIntegrationWithCriticalError(auth: Auth) {
    return !!integrationStates.value?.[auth.id]?.isCritical;
}

async function editParentAuth(authId: string) {
    let result = await getAuthById(authId);
    if (result.isSuccess) {
        editParentAuthDialog.value = {
            visible: true,
            auth: result.data.auth,
            platform: result.data.platform
        };
    }
}

function openSelectAuthDialog(platform: PlatformInterface) {
    addIntegrationDialog.value = null;
    nextTick(() => {
        addIntegrationDialog.value = {
            visible: true,
            platformId: platform.id
        };
    });
}

const OPEN_LINK = "openLink";
const OPEN_RENAME_DIALOG = "openRenameDialog";

let renameDialog = ref<{
    visible: boolean,
    model: {
        authId: string,
        descr: string
    }
}>();

function onAuthDescrCommand(command: string, auth: Auth) {
    if (command === OPEN_LINK) {
        window.open(auth.link);
    } else if (command === OPEN_RENAME_DIALOG) {
        renameDialog.value = {
            visible: true,
            model: {
                authId: auth.id,
                descr: auth.descr
            }
        };
    }
}

async function makeRename() {
    let result = await LcabApiRequest.save({
        url: `/api/client/integrations/${renameDialog.value.model.authId}/renameAuth`,
        p: {
            descr: renameDialog.value.model.descr
        }
    });
    if (result.isSuccess) {
        emits("reload");
        renameDialog.value = null;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, { class: "el-row-root" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, null, {
          default: _withCtx(() => [
            (_unref(empty) === false || __props.platformTypeId == _unref(INTEGRATION_PLATFORM_TYPE_CRM))
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 0,
                  class: _normalizeClass({
                'sticky sticky-top': true,
                'mb-5': !_unref(props).showEmptyAsCard
            })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showAddIntegrationDialog(null)))
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("Добавить интеграцию ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            (_unref(addIntegrationDialog))
              ? (_openBlock(), _createBlock(SelectIntegrationAuthDialog, {
                  "platform-type-id": __props.platformTypeId,
                  visible: _unref(addIntegrationDialog).visible,
                  "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(addIntegrationDialog).visible) = $event)),
                  "platform-id": _unref(addIntegrationDialog).platformId,
                  key: _unref(addIntegrationDialog).platformId,
                  "for-online-chat": "",
                  onSelect: onSelectNewAuth,
                  onReload: reload
                }, null, 8, ["platform-type-id", "visible", "platform-id"]))
              : _createCommentVNode("", true),
            (!_unref(isLoading))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (_unref(empty) === true)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent((__props.showEmptyAsCard && __props.platformsDictionary) ? 'el-card' : 'div'), {
                        key: 0,
                        class: "mb-5"
                      }, {
                        default: _withCtx(() => [
                          (__props.showEmptyAsCard)
                            ? (_openBlock(), _createBlock(ElCardHeader, {
                                key: 0,
                                title: "У Вас пока что не добавлено ни одной интеграции"
                              }))
                            : _createCommentVNode("", true),
                          (_openBlock(), _createBlock(_resolveDynamicComponent(__props.showEmptyAsCard ? ElCardSection : 'div'), null, {
                            default: _withCtx(() => [
                              _cache[9] || (_cache[9] = _createElementVNode("p", null, "Вы можете добавить первую интеграцию прямо сейчас:", -1)),
                              _createVNode(BigIconFlexButtonWrapper, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.platformsDictionary, (platform) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                      (platform.isReadyToUse && !platform.parentId)
                                        ? (_openBlock(), _createBlock(BigIconFlexButton, {
                                            key: 0,
                                            icon: platform.icon,
                                            descr: platform.descr,
                                            "icon-color": platform.color,
                                            onClick: ($event: any) => (openSelectAuthDialog(platform))
                                          }, _createSlots({ _: 2 }, [
                                            (_unref(siteIsFree) && !platform.isAvailableForFreeOnlineChat)
                                              ? {
                                                  name: "extraDescr",
                                                  fn: _withCtx(() => [
                                                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-danger" }, " Недоступно в бесплатной версии ", -1))
                                                  ]),
                                                  key: "0"
                                                }
                                              : undefined
                                          ]), 1032, ["icon", "descr", "icon-color", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 256))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(integrationsList), (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.platform.id,
                          style: {"margin-bottom":"4em"}
                        }, [
                          _createVNode(_component_el_button, {
                            class: "float-right d-none d-md-inline-block",
                            type: "primary",
                            plain: "",
                            onClick: ($event: any) => (showAddIntegrationDialog(item.platform.id))
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("Добавить интеграцию ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createElementVNode("h3", _hoisted_1, [
                            _createElementVNode("span", null, [
                              _createVNode(FontAwesomeIcon, {
                                class: "mr-1",
                                icon: item.platform.icon,
                                style: _normalizeStyle({
                                        color: item.platform.color
                                    })
                              }, null, 8, ["icon", "style"]),
                              _createTextVNode(" " + _toDisplayString(item.platform.descr), 1)
                            ]),
                            (item.platform.notGuaranteedText)
                              ? (_openBlock(), _createBlock(_component_el_tooltip, { key: 0 }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.platform.notGuaranteedText, (line, index) => {
                                        return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(line), 1))
                                      }), 128))
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(StatusTag, {
                                      class: "ml-2",
                                      descr: "Работа не гарантирована",
                                      color: "red"
                                    })
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.authList, (auth) => {
                            return (_openBlock(), _createBlock(_component_el_card, {
                              key: auth.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(ElCardSection, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                      _createElementVNode("div", _hoisted_3, [
                                        (auth.avatar)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: auth.avatar,
                                              class: "avatar mr-3"
                                            }, null, 8, _hoisted_4))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_5, [
                                          _createVNode(_component_el_dropdown, {
                                            trigger: "click",
                                            onCommand: ($event: any) => (onAuthDescrCommand($event, auth))
                                          }, {
                                            dropdown: _withCtx(() => [
                                              _createVNode(_component_el_dropdown_menu, null, {
                                                default: _withCtx(() => [
                                                  (auth.link)
                                                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                        key: 0,
                                                        command: OPEN_LINK
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(FontAwesomeIcon, {
                                                            icon: "share",
                                                            class: "mr-2"
                                                          }),
                                                          _cache[11] || (_cache[11] = _createTextVNode(" Перейти ", -1))
                                                        ]),
                                                        _: 1
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  _createVNode(_component_el_dropdown_item, { command: OPEN_RENAME_DIALOG }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(FontAwesomeIcon, {
                                                        icon: "pencil",
                                                        class: "mr-2"
                                                      }),
                                                      _cache[12] || (_cache[12] = _createTextVNode(" Переименовать ", -1))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                              _createElementVNode("h5", _hoisted_6, [
                                                _createElementVNode("a", _hoisted_7, _toDisplayString(auth.descr), 1)
                                              ])
                                            ]),
                                            _: 2
                                          }, 1032, ["onCommand"]),
                                          _createElementVNode("div", _hoisted_8, [
                                            (auth.parentAuth)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                  _createTextVNode(" Владелец интеграции: " + _toDisplayString(auth.parentAuth.descr) + " ", 1),
                                                  _createVNode(_component_el_tooltip, {
                                                    content: "Редактировать подключение",
                                                    class: "ml-1"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(MyIconButton, {
                                                        edit: "",
                                                        class: "p-0",
                                                        onClick: ($event: any) => (editParentAuth(auth.parentAuth.id))
                                                      }, null, 8, ["onClick"])
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  (_unref(integrationStates) && _unref(integrationStates)[auth.parentAuth.id])
                                                    ? (_openBlock(), _createBlock(IntegrationState, {
                                                        key: 0,
                                                        "is-critical": _unref(integrationStates)[auth.parentAuth.id].isCritical,
                                                        descr: _unref(integrationStates)[auth.parentAuth.id].descr,
                                                        platform: auth.parentAuth.platform
                                                      }, null, 8, ["is-critical", "descr", "platform"]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_unref(channels) && _unref(channels)[auth.id])
                                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(channels)[auth.id], (channel) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: channel.id
                                                  }, [
                                                    _createTextVNode(_toDisplayString(channel.descr) + ": ", 1),
                                                    (channel.isValidate)
                                                      ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                                                          key: 0,
                                                          icon: "check",
                                                          color: "green"
                                                        }))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(channel.errorDescr), 1))
                                                  ]))
                                                }), 128))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                          (_unref(integrationStates) == null)
                                            ? (_openBlock(), _createBlock(MyLoader, { key: 0 }))
                                            : (_unref(integrationStates)[auth.id] != null)
                                              ? (_openBlock(), _createBlock(IntegrationState, {
                                                  key: 1,
                                                  platform: item.platform,
                                                  descr: _unref(integrationStates)[auth.id].descr,
                                                  "is-critical": _unref(integrationStates)[auth.id].isCritical
                                                }, null, 8, ["platform", "descr", "is-critical"]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                  (_unref(balance)[auth.id])
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(balance)[auth.id].descr) + ": " + _toDisplayString(_unref(balance)[auth.id].sum), 1))
                                                    : _createCommentVNode("", true),
                                                  _createVNode(FontAwesomeIcon, {
                                                    class: "text-green",
                                                    icon: "check"
                                                  })
                                                ]))
                                        ])
                                      ])
                                    ]),
                                    _createVNode(BigIconFlexButtonWrapper, { class: "buttons" }, {
                                      default: _withCtx(() => [
                                        _createVNode(BigIconFlexButton, {
                                          onClick: ($event: any) => (editIntegration(auth, item.platform)),
                                          descr: item.platform.isAuthEditable ? (isIntegrationWithCriticalError(auth) ? 'Исправить подключение' : 'Редактировать подключение') : 'Параметры подключения',
                                          "button-type": isIntegrationWithCriticalError(auth) ? 'danger' : null,
                                          icon: item.platform.isAuthEditable ? 'pencil' : 'plug'
                                        }, null, 8, ["onClick", "descr", "button-type", "icon"]),
                                        (__props.showAdditionalAuthConfigButton && auth.additionalConfigForm)
                                          ? (_openBlock(), _createBlock(BigIconFlexButton, {
                                              key: 0,
                                              onClick: ($event: any) => (editAdditionalChatConfig(auth)),
                                              descr: "Дополнительные настройки",
                                              icon: "cogs"
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true),
                                        _renderSlot(_ctx.$slots, "buttons", _mergeProps({ ref_for: true }, {platform: item.platform, auth: auth}))
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      }), 128)),
                  _renderSlot(_ctx.$slots, "after-cards"),
                  (_unref(additionalAuthConfigDialogRef) && _unref(additionalAuthConfigDialogRef).visible)
                    ? (_openBlock(), _createBlock(AdditionalAuthConfigDialog, {
                        key: 2,
                        visible: _unref(additionalAuthConfigDialogRef).visible,
                        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(additionalAuthConfigDialogRef).visible) = $event)),
                        "auth-id": _unref(additionalAuthConfigDialogRef).authId
                      }, null, 8, ["visible", "auth-id"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    (_unref(editIntegrationDialog) && _unref(editIntegrationDialog).visible)
      ? (_openBlock(), _createBlock(IntegrationAuthDialog, {
          key: 0,
          platform: _unref(editIntegrationDialog).platform,
          platforms: [_unref(editIntegrationDialog).platform],
          visible: _unref(editIntegrationDialog).visible,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_unref(editIntegrationDialog).visible) = $event)),
          value: _unref(editIntegrationDialog).auth,
          "platform-type-id": __props.platformTypeId,
          onSave: reload
        }, null, 8, ["platform", "platforms", "visible", "value", "platform-type-id"]))
      : _createCommentVNode("", true),
    (_unref(editParentAuthDialog) && _unref(editParentAuthDialog).visible)
      ? (_openBlock(), _createBlock(IntegrationAuthDialog, {
          key: 1,
          platform: _unref(editParentAuthDialog).platform,
          platforms: [_unref(editParentAuthDialog).platform],
          visible: _unref(editParentAuthDialog).visible,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_unref(editParentAuthDialog).visible) = $event)),
          value: _unref(editParentAuthDialog).auth,
          "platform-type-id": __props.platformTypeId,
          onAuthCreated: reload
        }, null, 8, ["platform", "platforms", "visible", "value", "platform-type-id"]))
      : _createCommentVNode("", true),
    (_unref(renameDialog))
      ? (_openBlock(), _createBlock(MyDialog, {
          key: 2,
          visible: _unref(renameDialog).visible,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_unref(renameDialog).visible) = $event)),
          title: "Переименование интеграции",
          onApply: makeRename
        }, {
          default: _withCtx(() => [
            _cache[13] || (_cache[13] = _createElementVNode("p", null, "Введите новое название:", -1)),
            _createElementVNode("p", null, [
              _createVNode(_component_el_input, {
                modelValue: _unref(renameDialog).model.descr,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(renameDialog).model.descr) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})